module.exports = {
    "dismiss": `Rejeter`
};


//# sourceMappingURL=fr-FR.main.js.map
